import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./edit-project-cycle.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./edit-project-cycle.component.scss?ngResource";
import { ChangeDetectorRef, Component, Input } from "@angular/core";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AppControllerService } from "../../../../../app-controller.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { AlertType } from "../../../../../shared/models/alert";
import { EditprojectCycleConstants } from "./edit-project-cycle.constants";
import { projectCycleFormConstants } from "../shared/project-cycle-form/project-cycle-form.constants";
import { AutoUnsub } from "../../../../../shared/decorators/autounsub.decorator";
import { switchMap } from "rxjs";
import { SettingsService } from "../../../settings.service";
import { DatePipe } from "@angular/common";
import { AttachmentManagerService } from "../../../../../shared/components/attachment-manager/shared/services/attachment-manager.service";
import { AppConfig } from "../../../../../app.config";
let EditprojectCycleComponent = class EditprojectCycleComponent {
    activeModal;
    attachmentManagerService;
    appController;
    datePipe;
    settingsService;
    changeDetectorRef;
    projectCycleToEdit;
    componentType = SharedConstants.ADD_PROJECT_CYCLE_COMPONENT_TYPE;
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    dialogTitle = EditprojectCycleConstants.COMPONENT_NAME;
    saveLabel = SharedConstants.SAVE_LABEL;
    cancelLabel = SharedConstants.CANCEL_LABEL;
    showCompletedCheckbox = true;
    editValuationRunForm;
    showCopyProjectCycle = false;
    patchprojectCycleObservable;
    attachmentIdList;
    constructor(activeModal, attachmentManagerService, appController, datePipe, settingsService, changeDetectorRef) {
        this.activeModal = activeModal;
        this.attachmentManagerService = attachmentManagerService;
        this.appController = appController;
        this.datePipe = datePipe;
        this.settingsService = settingsService;
        this.changeDetectorRef = changeDetectorRef;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.branding = AppConfig.settings.projectSettings.styling;
        }
    }
    ngOnInit() {
        this.editValuationRunForm = new FormGroup({
            name: new FormControl(this.projectCycleToEdit.name, [Validators.required, Validators.maxLength(250)]),
            description: new FormControl(this.projectCycleToEdit.description, Validators.required),
            fromDate: new FormControl(this.datePipe.transform(this.projectCycleToEdit.fromDate, "yyyy-MM-dd"), Validators.required),
            toDate: new FormControl(this.datePipe.transform(this.projectCycleToEdit.toDate, "yyyy-MM-dd"), Validators.required),
            projectDocumentation: new FormControl(null),
            completed: new FormControl(this.projectCycleToEdit.completed)
        });
        this.changeDetectorRef.markForCheck();
        this.initializeData();
    }
    onBtnCancelClicked() {
        this.activeModal.close();
    }
    initializeData() {
        this.attachmentManagerService.getPcAttachmentAttachments(this.projectCycleToEdit.id, +this.appController.selectedModuleID).subscribe(x => {
            x.forEach(a => {
                this.attachmentManagerService.selectSavedAttachment(a);
            });
            return x;
        });
    }
    onBtnSaveClicked() {
        this.editValuationRunForm.get(projectCycleFormConstants.PROJECT_DOCUMENTATION_CONTROL).markAsTouched();
        if (this.editValuationRunForm.valid) {
            this.attachmentIdList = this.editValuationRunForm.get(projectCycleFormConstants.PROJECT_DOCUMENTATION_CONTROL)?.value?.attachmentList?.attachmentList;
            if (this.attachmentIdList == null || this.attachmentIdList.length === 0) {
                this.appController.showMessage(projectCycleFormConstants.ValidationMessage.projectDocumentation.required, AlertType.Warning);
                return;
            }
            const newRun = {
                name: this.editValuationRunForm.get(projectCycleFormConstants.NAME_FORM_CONTROL).value,
                description: this.editValuationRunForm.get(projectCycleFormConstants.DESCRIPTION_FORM_CONTROL).value,
                fromDate: this.editValuationRunForm.get(projectCycleFormConstants.FROM_DATE_FORM_CONTROL).value,
                toDate: this.editValuationRunForm.get(projectCycleFormConstants.TO_DATE_FORM_CONTROL).value,
                completed: this.editValuationRunForm.get(projectCycleFormConstants.COMPLETED_FORM_CONTROL).value
            };
            this.patchprojectCycleObservable = this.settingsService.patchprojectCycles(this.projectCycleToEdit.id, newRun);
            this.patchprojectCycleObservable.pipe(switchMap(response => {
                const saveAttachmentModel = {
                    attachments: []
                };
                this.attachmentIdList.forEach(x => {
                    saveAttachmentModel.attachments.push({
                        attachmentId: x.id,
                        projectCycleId: this.projectCycleToEdit.id,
                        deleted: false
                    });
                });
                return this.settingsService.saveProjectCyclesAttachment(this.projectCycleToEdit.id, saveAttachmentModel);
            })).subscribe({
                next: (response) => {
                    this.saveComplete(true);
                },
                error: (error) => {
                    this.appController.handleServerErrorMessage(this.dialogTitle, error, CRUDOperation.Update);
                }
            });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    saveComplete(response) {
        if (response) {
            this.appController.showMessage(SharedConstants.UPDATE_SUCCESS, AlertType.Success);
            this.activeModal.close(true);
        }
        else {
            this.appController.showMessage(SharedConstants.UPDATE_FAILED, AlertType.Error);
        }
    }
    static ctorParameters = () => [
        { type: NgbActiveModal },
        { type: AttachmentManagerService },
        { type: AppControllerService },
        { type: DatePipe },
        { type: SettingsService },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        projectCycleToEdit: [{ type: Input }]
    };
};
EditprojectCycleComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-edit-project-cycle",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], EditprojectCycleComponent);
export { EditprojectCycleComponent };
